import { render, staticRenderFns } from "./SupaStandardSearchPage.vue?vue&type=template&id=048f6faa&"
import script from "./SupaStandardSearchPage.vue?vue&type=script&lang=js&"
export * from "./SupaStandardSearchPage.vue?vue&type=script&lang=js&"
import style0 from "./SupaStandardSearchPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports